import { render, staticRenderFns } from "./Orderdetail.vue?vue&type=template&id=8c1ef274"
import script from "./Orderdetail.vue?vue&type=script&lang=js"
export * from "./Orderdetail.vue?vue&type=script&lang=js"
import style0 from "./Orderdetail.vue?vue&type=style&index=0&id=8c1ef274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports